import Page from '../base/Page';
import 'bootstrap3/js/tab';

export default class DashboardPage extends Page
{
    constructor() {
        super('.dashboard-page');
    }

    init() {
        this.childElements('.nav-tabs').tab();
    }
}